import React, { useState } from "react";
import { TextField } from "@mui/material";

const PasswordField = ({ label, value, onChange, confirmValue, confirmOnChange, disabled }) => {
  const [error, setError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
    return passwordRegex.test(password)
      ? ""
      : "Password must be at least 8 characters long, include at least one uppercase letter, one lowercase letter, and one special character.";
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    const validationError = validatePassword(newPassword);
    setError(validationError);
    onChange(newPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    if (newConfirmPassword !== value) {
      setConfirmError("Passwords do not match.");
    } else {
      setConfirmError("");
    }
    confirmOnChange(newConfirmPassword);
  };

  return (
    <>
      <TextField
        label={label || "Password"}
        type="password"
        fullWidth
        margin="normal"
        value={value}
        onChange={handlePasswordChange}
        error={!!error}
        helperText={error}
        disabled={disabled}
      />
      {confirmValue !== undefined && confirmOnChange && (
        <TextField
          label="Confirm Password"
          type="password"
          fullWidth
          margin="normal"
          value={confirmValue}
          onChange={handleConfirmPasswordChange}
          error={!!confirmError}
          helperText={confirmError}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default PasswordField;
